import { Routes } from '@angular/router';
import { TimeTrackerComponent } from './time-tracker/time-tracker.component';
import { EffortsManagementComponent } from './efforts-management/efforts-management.component';
import { UserAdministrationComponent } from './user-administration/user-administration.component';
import { EffortsResolver } from './resolvers/efforts.resolver';
import { ProjectManagementComponent } from './project-management/project-management.component';
import { ProjectsResolver } from './resolvers/projects.resolver';
import { AuthGuard } from './guards/auth.guard';
import { ReportsComponent } from './components/reports/reports.component';
import { SettingsComponent } from './components/settings/settings.component';
import { GroupManagementComponent } from './components/group-management/group-management.component';
import { SubmissionsComponent } from './components/submissions/submissions.component';
import { CurrentUserResolver } from './resolvers/current-user.resolver';
import { HelpComponent } from './components/help/help.component';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { RoleGuard } from './guards/role.guard';
import { FeedbackComponent } from './components/feedback/feedback.component';
import { PendingChangesGuard } from './guards/can-deactivate.guard';

export const routes: Routes = [
    { path: 'help', component: HelpComponent, canActivate: [] },
    { path: 'unauthorized', component: UnauthorizedComponent, canActivate: [ AuthGuard ]},
    { path: '', redirectTo: 'timesheet', pathMatch: 'full' }, // Default route
    {
        path: '',
        // resolve: { currentUser: CurrentUserResolver },
        // runGuardsAndResolvers: 'always',
        canActivate: [AuthGuard, RoleGuard],
        children: [
            { path: 'timesheet', component: TimeTrackerComponent },
            { path: 'efforts', component: EffortsManagementComponent },
            { path: 'projects', component: ProjectManagementComponent },
            { path: 'users', component: UserAdministrationComponent },
            { path: 'departments', component: GroupManagementComponent },
            { path: 'settings', component: SettingsComponent },
            { path: 'submissions', component: SubmissionsComponent, canDeactivate: [ PendingChangesGuard ] },
            { path: 'reports', component: ReportsComponent },
            { path: 'feedback', component: FeedbackComponent },
            { path: '**', redirectTo: 'timesheet' } // Fallback
        ]
    }
];
